<template>
  <div>
    <p class="cm-mg-p-wzd">1. {{ $t('irrigation.engine_info') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('irrigation.engine')}: *`"
          v-model="model.engine"
          name="irrigation.engine"
          :placeholder="$t('irrigation.engine')"
          v-validate="'required'"
          :error="getError('irrigation.engine', true)"
        ></fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('irrigation.design')}: *`"
          v-model="model.design"
          name="irrigation.design"
          :placeholder="$t('irrigation.engine_design')"
          v-validate="'required'"
          :error="getError('irrigation.design', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${$t('devices.brand')}: *`"
          :placeholder="$t('devices.brand')"
          v-model="model.brand"
          name="devices.brand"
          v-validate="'required'"
          :error="getError('devices.brand', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${$t('irrigation.model')}: *`"
          :placeholder="$t('irrigation.model')"
          v-model="model.model"
          name="irrigation.model"
          v-validate="'required'"
          :error="getError('irrigation.model', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('irrigation.energy_source_select') }} *</label
          >
          <el-select
            id="energy_source"
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.energy_source_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in energy_sources"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
          <!-- <fg-input
                type="text"
                label="Fuente de energia: "
                placeholder="Fuente de energia"
                v-model="model.energy_source"
                name="Fuente de energia"
                v-validate="'required'"
                :error="getError('Fuente de energia')"
              ></fg-input> -->
        </div>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.description')}: `"
          :placeholder="$t('common_words.description')"
          v-model="model.description"
          name="Descripción"
        ></fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_a_farm') }} *</label
          >
          <br />
          <el-select
            id="farm_engine"
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.farm_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            @change="changeFarm"
          >
            <el-option
              v-for="option in farms"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  components: {},

  props: {
    farms: {
      type: Array,
      required: true,
    },
    energy_sources: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      model: {
        engine: null,
        design: null,
        brand: null,
        model: null,
        description: null,
        farm_id: null,
        energy_source_id: null,
      },
      // farms:[]
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],

  methods: {
    changeFarm() {
      this.$emit('changeFarm');
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        Object.keys(this.model).forEach((prop) => {
          if (prop == null || prop == '') {
            return false;
          }
        });

        if (this.model.farm_id == null || this.model.farm_id == '') {
          let sel = document.getElementById('farm_engine');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        if (
          this.model.energy_source_id == null ||
          this.model.energy_source_id == ''
        ) {
          let sel = document.getElementById('energy_source');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        this.$emit('on-validated', res, this.model);
        // this.$emit("fillWizardForm", "firstStep");
        return res;
      });
    },
  },
  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.engine = editForm.engine;
      this.model.design = editForm.design;
      this.model.description = editForm.description;
      this.model.model = editForm.model;
      this.model.brand = editForm.brand;
      this.model.farm_id = editForm.farm_id;
      this.model.energy_source_id = editForm.energy_source_id;
    }
    // this.$emit("fillWizardForm", "firstStep");
  },
};
</script>
